import { JhiCapitalizePipe } from 'ng-jhipster';

import { DatePipe } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { AddressComponent } from './components/address/address.component';
import { JhiAlertComponent } from './components/alert/alert.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CaptchaValidatorDirective } from './components/captcha/captcha-validator';
import { CaptchaComponent } from './components/captcha/captcha.component';
import { ChangelogComponent } from './components/changelog/changelog.component';
import { CguComponent } from './components/conditions-generales/cgu.component';
import { ContactComponent } from './components/contact/contact.component';
import { DraftModalComponent } from './components/draft-modal/draft-modal.component';
import { FicheActeurComponent } from './components/fiche-acteur/fiche-acteur.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { TelerecoursFormModule } from './components/forms/form.module';
import { FranceConnectButtonComponent } from './components/franceConnect-button/franceConnect-button.component';
import { IdentiteOrganismeComponent } from './components/identite-organisme/identite-organisme.component';
import { NomEntrepriseComponent } from './components/identite-organisme/nom-entreprise/nom-entreprise.component';
import { CiviliteComponent } from './components/identite-personne/civilite/civilite.component';
import { IdentitePersonneComponent } from './components/identite-personne/identite-personne.component';
import { JumbotronComponent } from './components/jumbotron/jumbotron.component';
import { PiecePostalesComponent } from './components/piece-postales/piece-postales.component';
import { PreviewPieceComponent } from './components/preview-piece/preview-piece.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { SectionModule } from './components/section/section.module';
import { CustomAlphaStringDirective } from './directives/alpha-string.directive';
import { CustomCapitalizeDirective } from './directives/capitalize.directive';
import { IgnoreDirtyDirective } from './directives/ignore-dirty.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { TrcAlphaStringPipe } from './pipes/alpha-string.pipe';
import { CustomCapitalizePipe } from './pipes/capitalize.pipe';
import { FormatFileSizePipe } from './pipes/format-file-size.pipe';
import { FindLanguageFromKeyPipe } from './pipes/language.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { JhiLanguageHelper } from './services/language.helper';
import { TelerecourspnrSharedLibsModule } from './shared-libs.module';
import { TrapFocusDirective } from './directives/trap-focus.directive';
import { A11yDragNDropDirective } from './directives/a11y-drag-n-drop.directive';
import { AdBlockDetectorComponent } from './components/adblocker-detector/adblocker-detector.component';
import { TRCAdminConfigComponent } from './components/trc-admin-config/trc-admin-config.component';

@NgModule({
    imports: [TelerecourspnrSharedLibsModule, TelerecoursFormModule, SectionModule],
    declarations: [
        OnlyNumbersDirective,
        CustomCapitalizePipe,
        SafeHtmlPipe,
        LocalDatePipe,
        FormatFileSizePipe,
        CustomCapitalizeDirective,
        FindLanguageFromKeyPipe,
        JhiAlertComponent,
        PiecePostalesComponent,
        PreviewPieceComponent,
        FileUploaderComponent,
        FicheActeurComponent,
        FranceConnectButtonComponent,
        JumbotronComponent,
        CguComponent,
        CaptchaComponent,
        CaptchaValidatorDirective,
        BreadcrumbComponent,
        ProgressSpinnerComponent,
        AddressComponent,
        IdentitePersonneComponent,
        IdentiteOrganismeComponent,
        ContactComponent,
        DraftModalComponent,
        CiviliteComponent,
        NomEntrepriseComponent,
        ChangelogComponent,
        TrcAlphaStringPipe,
        CustomAlphaStringDirective,
        IgnoreDirtyDirective,
        TrapFocusDirective,
        A11yDragNDropDirective,
        AdBlockDetectorComponent,
        TRCAdminConfigComponent
    ],
    providers: [
        JhiLanguageHelper,
        Title,
        {
            provide: LOCALE_ID,
            useValue: 'fr'
        },
        DatePipe,
        LocalDatePipe,
        FormatFileSizePipe,
        JhiCapitalizePipe,
        CustomCapitalizePipe,
        SafeHtmlPipe,
        TrcAlphaStringPipe
    ],
    exports: [
        TelerecourspnrSharedLibsModule,
        TelerecoursFormModule,
        SectionModule,
        FindLanguageFromKeyPipe,
        JhiAlertComponent,
        PiecePostalesComponent,
        PreviewPieceComponent,
        FileUploaderComponent,
        FicheActeurComponent,
        FranceConnectButtonComponent,
        JumbotronComponent,
        CguComponent,
        CaptchaComponent,
        CaptchaValidatorDirective,
        BreadcrumbComponent,
        ProgressSpinnerComponent,
        AddressComponent,
        IdentitePersonneComponent,
        IdentiteOrganismeComponent,
        ContactComponent,
        DraftModalComponent,
        CiviliteComponent,
        NomEntrepriseComponent,
        DatePipe,
        LocalDatePipe,
        FormatFileSizePipe,
        OnlyNumbersDirective,
        CustomCapitalizeDirective,
        SafeHtmlPipe,
        ChangelogComponent,
        CustomAlphaStringDirective,
        IgnoreDirtyDirective,
        TrapFocusDirective,
        A11yDragNDropDirective,
        AdBlockDetectorComponent,
        TRCAdminConfigComponent
    ]
})
export class TelerecourspnrSharedCommonModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared-common.module.ts